// app/javascript/controllers/rs_script/money_input_controller.js
import { Controller } from "@hotwired/stimulus"

// Контроллер для ввода денежных сумм с разделителем разрядов.
// Показывает пользователю "1 000 000", а при submit отправляет "1000000".
//
// HTML:
// <div data-controller="money-input">
//   <input type="text" data-money-input-target="display"
//          data-action="input->money-input#format" inputmode="numeric" placeholder="0">
//   <input type="hidden" data-money-input-target="raw" name="amount">
// </div>
//
export default class extends Controller {
  static targets = ["display", "raw"]

  connect() {
    // Форматируем начальное значение если есть
    if (this.displayTarget.value) {
      this.format()
    }
  }

  format() {
    const input = this.displayTarget
    const cursorPos = input.selectionStart

    // Убираем всё кроме цифр и точки/запятой
    let raw = input.value.replace(/[^\d.,]/g, '')
    // Заменяем запятую на точку
    raw = raw.replace(',', '.')

    // Разделяем целую и дробную части
    const parts = raw.split('.')
    let intPart = parts[0].replace(/^0+(?=\d)/, '') || '0' // убираем ведущие нули
    const decPart = parts.length > 1 ? '.' + parts[1].slice(0, 2) : ''

    // Записываем сырое значение в hidden input
    if (this.hasRawTarget) {
      this.rawTarget.value = intPart + decPart
    }

    // Форматируем целую часть с пробелами (разделители разрядов)
    const formatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + decPart

    // Вычисляем новую позицию курсора
    const oldLen = input.value.length
    input.value = formatted
    const newLen = formatted.length
    const newPos = Math.max(0, cursorPos + (newLen - oldLen))
    input.setSelectionRange(newPos, newPos)
  }
}
